const config = {
  baseUrl: 'https://beta-api.dimorder.com',
};

export default config;
